export const defaultSwiperOptions = {};
